var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { translate } from '@utils/i18n';
import { Modal } from '@components/v2/Modal';
import { Button, Text, TextArea, Radio } from '@ui';
import './OverridePopup.scss';
const namespace = 'features.iim_review.ipa.override_popup';
export default function OverridePopup({ isOpen, onClose, onSave, fieldLabel, originalValue, newValue, options, onNewValueChange, busy = false }) {
    const [reason, setReason] = useState('');
    const displayLabel = (value) => { var _a, _b; return (_b = (_a = options === null || options === void 0 ? void 0 : options.find((o) => o.value === value)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : value; };
    const handleClose = () => {
        setReason('');
        onClose();
    };
    const handleSave = () => __awaiter(this, void 0, void 0, function* () {
        yield onSave(reason.trim() || null);
        setReason('');
    });
    return (React.createElement(Modal, { title: translate('title', { namespace, defaultValue: 'Override AI-generated value' }), isOpen: isOpen, onClose: handleClose, className: "override-popup", width: "500px", footer: React.createElement(React.Fragment, null,
            React.createElement(Button, { onClick: handleClose, disabled: busy }, translate('cancel', { namespace, defaultValue: 'Cancel' })),
            React.createElement(Button, { variant: "primary", onClick: handleSave, disabled: busy || newValue === originalValue }, busy
                ? translate('saving', { namespace, defaultValue: 'Saving...' })
                : translate('save', { namespace, defaultValue: 'Save' }))) },
        React.createElement("div", { className: "override-popup__body" },
            React.createElement(Text, { variant: "body", as: "p", className: "override-popup__description" },
                translate('description', {
                    namespace,
                    defaultValue: 'You are about to override the AI-generated value for'
                }),
                ' ',
                React.createElement("strong", null, fieldLabel),
                "."),
            React.createElement("div", { className: "override-popup__values" },
                React.createElement("div", { className: "override-popup__value-block" },
                    React.createElement(Text, { as: "span", className: "override-popup__value-label" }, translate('original', { namespace, defaultValue: 'Original' })),
                    React.createElement(Text, { as: "span", className: "override-popup__value-text" }, displayLabel(originalValue))),
                React.createElement("div", { className: "override-popup__value-block override-popup__value-block--new" },
                    React.createElement(Text, { as: "span", className: "override-popup__value-label" }, translate('new', { namespace, defaultValue: 'New' })),
                    options && onNewValueChange ? (React.createElement(Radio, { name: "override-new-value", options: options, value: newValue, onChange: onNewValueChange, disabled: busy })) : (React.createElement(Text, { as: "span", className: "override-popup__value-text" }, displayLabel(newValue))))),
            React.createElement(Text, { as: "label", htmlFor: "override-reason", className: "override-popup__reason-label" },
                translate('reason_label', { namespace, defaultValue: 'Reason' }),
                ' ',
                React.createElement(Text, { as: "span", className: "override-popup__optional" }, translate('optional', { namespace, defaultValue: '(optional)' }))),
            React.createElement(TextArea, { id: "override-reason", className: "override-popup__reason-textarea", value: reason, onChange: (e) => setReason(e.target.value), rows: 3, placeholder: translate('reason_placeholder', {
                    namespace,
                    defaultValue: 'Explain why you are overriding this value...'
                }), disabled: busy }))));
}
